import * as React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../../common/CreateSurveyProps';
import { validateString } from '../../common/helperFunctions';
import { EditObject } from '../../common/constants';
import { ApplicationState } from '../../store';
import * as CreateSurveyStore from '../../store/CreateSurvey';
import { iState } from '../../models/iState';

class Group extends React.Component<CreateSurveyProps, iState> {
    state = {
        validationChecked: false,
        generalErrorMessage: ''
    }

    handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        e.target.value = e.target.value;
            
        this.props.SetPropertyCreateSurvey(EditObject.Group, e.target.name, e.target.value, false, 0, new Date());
    };

    CancelAndMoveNext = () => {
        if (this.props.survey.questions.length > 0)
            this.props.MoveNextStep(undefined);
        else
            this.setState({...this.state, generalErrorMessage : 'Please add at least one question' });
    }

    ValidateAndSave = () => {
        if ((validateString(true, this.props.editGroup.groupHeadingEn, 1, -1) === false &&
            validateString(true, this.props.editGroup.groupSubHeadingEn, 1, -1) === false) ||
            (validateString(true, this.props.editGroup.groupHeadingFr, 1, -1) === false &&
            validateString(true, this.props.editGroup.groupSubHeadingFr, 1, -1) === false)) {
                
            this.setState({...this.state, validationChecked: true, generalErrorMessage : 'Please fill out the heading and/or subheading for English and Frehch both' });

            return;
        }

        this.props.EndGroupEdit(false);
        this.setState({...this.state, validationChecked: false, generalErrorMessage : ''});

    }

    handleGroupChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.props.StartGroupEdit(+e.target.value);
    }
    
    render() {
        return(
            <React.Fragment>
                <div className="row">
                    <div className='col-sm-12 pl-0'>
                        <div className="pt-1 pb-2 text-primary"><b>Note: </b>Assign group to question(s) in 'Summary' step. Group will be deleted automatically, if not assigned to any question</div>
                    </div>
                </div>
                <div className="row g-3 mt-0">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">Select a group to edit:</label>
                        <select className='form-select'
                            onChange={this.handleGroupChange}
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            value={ this.props.editGroup.groupId } >
                                <option value={-999999999}>[New]</option>
                            {
                                this.props.survey.groups.map((item, index) => {
                                    return (<option value={item.groupId} key={item.groupId + 'grpOption'}>{item.groupHeadingEn || item.groupSubHeadingEn}</option>)
                                })
                            }
                        </select>
                    </div>
                </div>

                <div className="row g-3 mt-5">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">Heading - English:</label>
                        <textarea className="form-control"
                            value={this.props.editGroup.groupHeadingEn}
                            onChange={this.handleTextAreaChange}
                            name='groupHeadingEn'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required></textarea>
                    </div>
                </div>
                <div className="row g-3">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">Heading - French:</label>
                        <textarea className="form-control"
                            value={this.props.editGroup.groupHeadingFr}
                            onChange={this.handleTextAreaChange}
                            name='groupHeadingFr'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required></textarea>
                    </div>
                </div>

                <div className="row g-3 mt-5">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">Sub Heading - English:</label>
                        <textarea className="form-control"
                            value={this.props.editGroup.groupSubHeadingEn}
                            onChange={this.handleTextAreaChange}
                            name='groupSubHeadingEn'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required></textarea>
                    </div>
                </div>
                <div className="row g-3">
                    <div className='col-sm-12'>
                        <label className="form-label fw-bold">Sub Heading - French:</label>
                        <textarea className="form-control"
                            value={this.props.editGroup.groupSubHeadingFr}
                            onChange={this.handleTextAreaChange}
                            name='groupSubHeadingFr'
                            disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                            required></textarea>
                    </div>
                </div>

                <div className="row g-3">
                    <div className='col-sm-12'>
                        <div className="invalid-feedback d-block pt-1 pb-2">{this.state.generalErrorMessage}</div>
                    </div>
                </div>

                <div className="col-sm-12 mt-5">
                    <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(this.props.step -1 )}>Previous</button>
                    <button className="btn btn-primary" onClick={() => this.ValidateAndSave()}
                        disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}>Add/Update</button>
                    <button className="btn btn-primary" onClick={() => this.CancelAndMoveNext()}>Cancel and Continue</button>
                    <button className="btn btn-outline-danger float-end" onClick={() => this.props.DeleteGroup(this.props.groupIndex)}>Delete</button>
                </div>
            </React.Fragment>
        );
    }
};

export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(Group as any);
